export enum PopUpType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
